module.exports = __webpack_public_path__ + "img/applyOverseaen.2b3d2703.png";